import { GetPlanOutput } from "@smash-sdk/billing";
import { DisplayUser } from "../../features/auth/models/DisplayUser.interface";
import { Plan } from "../../features/planUpgrade/models/Plan.interface";

export const events = {
  subscriptionApi: "subscription_api",
};

export function generateSubscriptionAPIGTMEvent({
  identity,
  plan,
}: {
  identity: DisplayUser;
  plan: GetPlanOutput["plan"] | Plan;
}) {
  return {
    event: events.subscriptionApi,
    account: identity?.id,
    username: identity?.username,
    plan_id: plan?.id,
    plan_name: plan?.name,
    plan_description: plan?.description,
    plan_currency: plan?.currency,
    plan_duration: plan?.duration,
    plan_price_excl_tax: plan?.priceExclTax,
    plan_data_in_out: plan?.limits.services.transfer.dataInOut.max,
  };
}

export function pushGTMEvent(event: any) {
  window.dataLayer = window.dataLayer || [];
  (window.dataLayer as any[]).push(event);
}
